<template>
  <div style="padding-bottom: 0.625rem">
    <div class="tui-headerTitle" v-if="List.length != 0">
      <div class="punctuation"></div>
      <div class="time">今天</div>
    </div>
    <el-row :gutter="20" style="margin-top: 10px">
      <el-col
        :span="8"
        v-for="(item, index) in List"
        :key="index"
        style="margin-bottom: 0.25rem"
      >
        <div class="grid-content" @click="onCLickCourseDetail(item)">
          <div
            class="tui-img"
            :style="{ backgroundImage: 'url(' + item.Image + ')' }"
          >
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230160103_4046.png"
              class="tui-pause"
              alt=""
            />
          </div>
          <div class="coulmn">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.TwoTitle"
              placement="top-start"
            >
              <div class="title">
                {{ item.TwoTitle }}
              </div>
            </el-tooltip>

            <div class="section flex-text">{{ item.Name }}</div>
            <div class="tag">#{{ item.OneTitle }}#</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <template v-if="TwoList.length != 0">
      <div class="tui-headerTitle">
        <div class="punctuation"></div>
        <div class="time">更早</div>
      </div>
      <el-row :gutter="20" style="margin-top: 10px">
        <el-col
          :span="8"
          v-for="(item, index) in TwoList"
          :key="index"
          style="margin-bottom: 0.25rem"
        >
          <div class="grid-content" @click="onCLickCourseDetail(item)">
            <div
              class="tui-img"
              :style="{ backgroundImage: 'url(' + item.Image + ')' }"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230160103_4046.png"
                class="tui-pause"
                alt=""
              />
            </div>
            <div class="coulmn">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.TwoTitle"
                placement="top-start"
              >
                <div class="title">
                  {{ item.TwoTitle }}
                </div>
              </el-tooltip>
              <div class="section flex-text">{{ item.Name }}</div>
              <div class="tag">#{{ item.OneTitle }}#</div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </template>
    <el-card v-if="List.length == 0 && TwoList.length == 0">
      <el-empty description="暂无数据"></el-empty>
    </el-card>
  </div>
</template>
<script>
import { GetOldStudyRecordInfo, GetTodayStudyRecordInfo } from "../../api/api";
export default {
  data() {
    return {
      userInfo: {},
      List: [],
      TwoList: [],
      PageIndex: 1,
      PageSize: 10,
      total: 0,
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetTodayStudyRecordInfo();
    this.GetOldStudyRecordInfo();
  },
  methods: {
    // 课程详情
    onCLickCourseDetail(item) {
      this.$router.push({
        path: "/Teacher-Tain/video",
        query: {
          obj: JSON.stringify(item),
        },
      });
    },
    async GetTodayStudyRecordInfo() {
      let res = await GetTodayStudyRecordInfo({
        Id: this.userInfo.TeacherId,
        PageIndex: 1,
        PageSize: 1000000,
        Name: "",
      });
      if (res.data.success) {
        this.List = res.data.response.data;
      }
    },
    async GetOldStudyRecordInfo() {
      let res = await GetOldStudyRecordInfo({
        Id: this.userInfo.TeacherId,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.TwoList = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.TwoList = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetOldStudyRecordInfo();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetOldStudyRecordInfo();
    },
  },
};
</script>
<style lang="less" scoped>
.flex-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 3.5rem;
}
.tag {
  color: #52cdff;
  font-size: 0.225rem;
}
.grid-content {
  // height: 2rem;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  padding: 0.3125rem;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  .coulmn {
    display: flex;
    flex-direction: column;
    padding-left: 0.1875rem;
    width: 100%;
    .section {
      color: #999999;
      font-size: 0.225rem;
      padding-bottom: 0.0375rem;
    }
    .headline {
      color: #52cdff;
      font-size: 0.225rem;
      font-weight: 600;
    }
    .title {
      color: #333333;
      font-size: 0.25rem;
      font-weight: 600;
      padding-bottom: 0.25rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 3.5rem;
    }
  }
  .tui-img {
    width: 1.6625rem;
    height: 1.3875rem;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    border-radius: 0.25rem;
    display: flex;
    flex-shrink: 0;
    .tui-pause {
      width: 0.4rem;
      height: 0.4rem;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
}
.tui-headerTitle {
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
  .punctuation {
    width: 0.075rem;
    height: 0.3rem;
    background: #27abf7;
    border-radius: 3px;
  }
  .time {
    color: #333333;
    font-size: 0.25rem;
    padding-left: 0.125rem;
    font-weight: 600;
  }
}
</style>